import React from "react";

import { ExperiencesBody } from "@src/features/personalizations/pages/personalizationOverview/Experiences.body";

export const ExperiencesRoute = () => {
  return <ExperiencesBody />;
};
